import { render, staticRenderFns } from "./BaseSelector.vue?vue&type=template&id=74ddd680&scoped=true"
import script from "./BaseSelector.vue?vue&type=script&lang=ts"
export * from "./BaseSelector.vue?vue&type=script&lang=ts"
import style0 from "./BaseSelector.vue?vue&type=style&index=0&id=74ddd680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ddd680",
  null
  
)

export default component.exports